import { css } from "@emotion/react";

export const styles = {
  link: css`
    text-decoration: underline;
    color: #00000099;
  `
};
